export const positiveWithPrecision = (precision: number) => ({
    isAllowed: (val: any) => val.floatValue === undefined || val.floatValue > 0, 
    decimalScale: precision, 
    fixedDecimalScale: true
})

export const withPrecision = (precision: number) => ({
    decimalScale: precision, 
    fixedDecimalScale: true
})